import { v4 as uuidv4 } from 'uuid';

export const TIME_FOR_THROW_DICE = 10;

export const TIME_FOR_GAME_LOADING = 20;

export const MIN_TIME_FOR_BOT_DICE = 2000;

export const MAX_TIME_FOR_BOT_DICE = 12000;

export const GAME = 'ludo';
export const ludoDefaultSafeHousePosition = [0, 52, 53, 54, 55, 56, 57];

export function getUniqueId() {
  return uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
}

/**
 * getCurrentUtcTimeStamp
 * @returns number
 */
export function getCurrentUtcTimeStamp(): number {
  const currentUTCTime = new Date(new Date().toUTCString());
  return currentUTCTime.valueOf();
}

/**
 * getTimeStamp
 * @param {Date[]} date
 * @returns number
 */
export function getTimeStamp(date: Date): number {
  return new Date(date).valueOf();
}

/**
 * getCurrentDate
 *
 * @export
 * @returns {Date}
 */
export function getCurrentDate(): Date {
  const date = new Date();
  date.setUTCHours(0);
  date.setUTCMinutes(0);
  date.setUTCSeconds(0);
  date.setUTCMilliseconds(0);
  return date;
}

/**
 * parseJson
 *
 * @export
 * @param {data} data
 * @returns {string | object }
 */
export function parseJson<T>(data: string): T | string {
  try {
    return JSON.parse(data);
  } catch (error) {
    return data;
  }
}

/**
 * getRandomInt
 * @param min
 * @param max
 * @returns random no
 */
export function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

/**
 * getTimeInMilliseconds is used for fetching time in milliseconds for a date
 *
 * @export
 * @param {Date} date
 * @returns {number}
 */
export function getTimeInMilliseconds(date: Date): number {
  return Number(new Date(date.toUTCString()).getTime());
}

/**
 * getDice Number
 * @export
 * @returns {number}
 */
export function getDiceNumber(maxNumber = 6): number {
  return getRandomInt(1, maxNumber);
}

/**
 * getNextPlayer Number
 * @export
 * @returns {number}
 */
export function getNextPlayer(currentPlayerIndex: number, playerLength: number): number {
  return (currentPlayerIndex + 1) % playerLength;
}

/**
 * getNextPlayer Number
 * @export
 * @returns {number}
 */
export function getStartingPosition(): { [key: string]: number } {
  return {
    1: 1,
    2: 14,
    3: 27,
    4: 40
  };
}

/**
 * asyncSetTimeOut
 * @export
 * @returns {void}
 */
export function asyncSetTimeOut(delay: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, delay);
  });
}

export const sendEventToGame = (payload: any) => {
  window.postMessage(payload, '*');
};
